import * as tslib_1 from "tslib";
import { mapHash } from '@fullcalendar/core';
import { parseResource } from '../structs/resource';
export default function (store, action, source, calendar) {
    switch (action.type) {
        case 'INIT':
            return {};
        case 'RECEIVE_RESOURCES':
            return receiveRawResources(store, action.rawResources, action.fetchId, source, calendar);
        case 'ADD_RESOURCE':
            return addResource(store, action.resourceHash);
        case 'REMOVE_RESOURCE':
            return removeResource(store, action.resourceId);
        case 'SET_RESOURCE_PROP':
            return setResourceProp(store, action.resourceId, action.propName, action.propValue);
        case 'RESET_RESOURCES':
            // must make the calendar think each resource is a new object :/
            return mapHash(store, function (resource) {
                return tslib_1.__assign({}, resource);
            });
        default:
            return store;
    }
}
function receiveRawResources(existingStore, inputs, fetchId, source, calendar) {
    if (source.latestFetchId === fetchId) {
        var nextStore = {};
        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
            var input = inputs_1[_i];
            parseResource(input, '', nextStore, calendar);
        }
        return nextStore;
    }
    else {
        return existingStore;
    }
}
function addResource(existingStore, additions) {
    // TODO: warn about duplicate IDs
    return tslib_1.__assign({}, existingStore, additions);
}
function removeResource(existingStore, resourceId) {
    var newStore = tslib_1.__assign({}, existingStore);
    delete newStore[resourceId];
    // promote children
    for (var childResourceId in newStore) { // a child, *maybe* but probably not
        if (newStore[childResourceId].parentId === resourceId) {
            newStore[childResourceId] = tslib_1.__assign({}, newStore[childResourceId], { parentId: '' });
        }
    }
    return newStore;
}
function setResourceProp(existingStore, resourceId, name, value) {
    var _a, _b;
    var existingResource = existingStore[resourceId];
    // TODO: sanitization
    if (existingResource) {
        return tslib_1.__assign({}, existingStore, (_a = {}, _a[resourceId] = tslib_1.__assign({}, existingResource, (_b = {}, _b[name] = value, _b)), _a));
    }
    else {
        return existingStore;
    }
}
